// extracted by mini-css-extract-plugin
module.exports = {"container":"event-card_container__jPiWi","text":"event-card_text__cVyNR","header":"event-card_header__FvQ5y"};